import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'representatives_json';

const mockRepresentatives = [
  {
    id: '1',
    name: 'Ali Hassan',
    phone: '0501111111',
    email: 'ali@company.com',
    username: 'ali.rep',
    password: 'rep123',
    status: 'Active',
  },
  {
    id: '2',
    name: 'Sara Khaled',
    phone: '0502222222',
    email: 'sara@company.com',
    username: 'sara.rep',
    password: 'rep456',
    status: 'Suspended',
  },
];

function loadRepresentatives() {
  const json = localStorage.getItem(LOCAL_KEY);
  let reps;
  if (json) {
    try {
      reps = JSON.parse(json);
    } catch {
      reps = mockRepresentatives;
    }
  } else {
    reps = mockRepresentatives;
  }
  return reps;
}

function saveRepresentatives(representatives) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(representatives));
}

const initialState = {
  representatives: loadRepresentatives(),
  filtered: loadRepresentatives(),
  filters: {
    status: '',
    search: '',
  },
};

const representativesSlice = createSlice({
  name: 'representatives',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
      let filtered = state.representatives;
      const { status, search } = state.filters;
      if (status) {
        filtered = filtered.filter(rep => rep.status === status);
      }
      if (search) {
        const s = search.toLowerCase();
        filtered = filtered.filter(rep =>
          rep.name.toLowerCase().includes(s) ||
          rep.phone.includes(s) ||
          rep.email.toLowerCase().includes(s) ||
          rep.username.toLowerCase().includes(s)
        );
      }
      state.filtered = filtered;
    },
    resetFilters(state) {
      state.filters = { status: '', search: '' };
      state.filtered = state.representatives;
    },
    addRepresentative(state, action) {
      state.representatives.push(action.payload);
      state.filtered = state.representatives;
      saveRepresentatives(state.representatives);
    },
    removeRepresentative(state, action) {
      state.representatives = state.representatives.filter(r => r.id !== action.payload);
      state.filtered = state.representatives;
      saveRepresentatives(state.representatives);
    },
    editRepresentative(state, action) {
      const idx = state.representatives.findIndex(r => r.id === action.payload.id);
      if (idx !== -1) {
        state.representatives[idx] = action.payload;
        state.filtered = state.representatives;
        saveRepresentatives(state.representatives);
      }
    },
  },
});

export const { setFilter, resetFilters, addRepresentative, removeRepresentative, editRepresentative } = representativesSlice.actions;
export default representativesSlice.reducer; 